import React from 'react';
import Tooltip from 'cccisd-tooltip';
import IconSpinner from 'cccisd-icons/spinner11';
import ConfigureVideo from './ConfigureVideo';
import ConfigureCaptions from './ConfigureCaptions';
import UploadVideo from './UploadVideo';
import PreviewVideo from './PreviewVideo';
import CopyEmbed from './CopyEmbed';
import CopyPreview from './CopyPreview';

const ConfigureColumnRender = props => {
    const isProcessing = Number(props.row.processingVersionCount) > 0;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem' }}>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
                <ConfigureVideo {...props} />
                <UploadVideo {...props} />
                <ConfigureCaptions {...props} />
                <PreviewVideo {...props} />
                <CopyEmbed {...props} />
                <CopyPreview {...props} />
            </div>
            {isProcessing && (
                <Tooltip title="A version of this video is still processing" placement="bottom">
                    <span className="badge bg-warning">
                        <IconSpinner spaceRight />
                        Processing
                    </span>
                </Tooltip>
            )}
        </div>
    );
};

export default () => {
    return props => <ConfigureColumnRender {...props} />;
};
